
namespace RioERP.Orders {
    export class OrderProductSpecificationsColumns {
        static columnsKey = 'Orders.OrderProductSpecifications';
    }
}